export enum EventType {
  PAGE_VIEW = 'page-view',
  VIDEO_PLAY = 'video-start-playing',
  FIRST_VIDEO_PLAY = 'first-video-start-playing',
  VIDEO_COMPLETED = 'video-completed',
  ADDED_BY_PIXELS = 'added-by-pixels',
  SWAPPED_BY_PIXELS = 'swapped-by-pixels',
  INJECTED_BY_PIXELS = 'injected-by-pixels',
}

export enum EventTypeV3 {
  PAGE_VIEW = 'page-view',
  AD = 'ad',
  VIDEO = 'video',
  EMBED = 'embed',
}

export interface AnalyticPayload {
  host: string;
  id: string;
  href: string;
  eventType: EventType;
  platform: string;
  campaignId?: string;
  heroVideoId?: string;
}

export interface AnalyticPayloadV3 {
  organisation: string;
  type: EventType;
  page_id: string;
  referrer: string;
  url: string;
  uuid: string;
  device: string;
  video_id?: string;
  design_variant?: string;
}

export interface SeedConfig {
  id: string;
  heroVideoId: string
}

export const NATIVE_PLATFORM = 'native';

const postRequest = <T>(endpoint: string, useXHR = true) => (payload: T) => {
  if (useXHR) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', endpoint, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(payload));
  } else {
    const blob = new Blob([JSON.stringify(payload)]);
    navigator.sendBeacon(endpoint, blob);
  }
};

export const sendBeacon = postRequest<AnalyticPayload>(__ANALYTICS_ENDPOINT__)
export const sendBeaconV3 = postRequest<AnalyticPayloadV3>(__ANALYTICS_ENDPOINT_V3__, false);
